import { render, staticRenderFns } from "./login-joinTeam.vue?vue&type=template&id=c0aa5f24&scoped=true&"
import script from "./login-joinTeam.vue?vue&type=script&lang=js&"
export * from "./login-joinTeam.vue?vue&type=script&lang=js&"
import style0 from "./login-joinTeam.vue?vue&type=style&index=0&id=c0aa5f24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa5f24",
  null
  
)

export default component.exports